<template>
  <div class="manager-wrapper">
    <slot
      :managers="managersData"
      :holdings="holdingsPageData"
      :loading="loading"
      :managersFinished="managersFinished"
      :holdingsFinished="holdingsFinished"
      :holdLoadMore="holdLoadMore"
    ></slot>
  </div>
</template>

<script>
export default {
  props: {
    total: Number
  },
  data() {
    return {
      loading: false,
      managersFinished: false,
      managers: [],
      holdingsFinished: false,
      holdings: [],
      holdingsPageNum: 0,
      holdingsPageSize: 20
    }
  },
  computed: {
    symbol() {
      return this.$route.query.symbol
    },
    market() {
      return this.$funs.getMarket(this.symbol)
    },
    managersData() {
      const managers = this.managers
      const holdings = this.holdings
      let mergeData = managers.map((mana) => {
        const hold = holdings.find((hold) => {
          return hold.holderName === mana.managerName
        })
        return { ...mana, ...hold }
      })
      return mergeData
        .sort((a, b) => {
          return (b.holdingNumber ?? 0) - (a.holdingNumber ?? 0)
        })
        .slice(0, this.total)
    },
    holdingsData() {
      let holdingsData = []
      if (this.market === 'hk') {
        const managers = this.managers
        const holdings = this.holdings
        managers.forEach((mana) => {
          const hold = holdings.find((hold) => {
            return hold.holderName === mana.managerName
          })
          if (hold) {
            holdingsData.push({ ...mana, ...hold })
          }
        })
      } else if (this.market === 'us') {
        holdingsData = JSON.parse(JSON.stringify(this.holdings))
      }
      return (
        holdingsData
          .sort((a, b) => b.reportDate.localeCompare(a.reportDate) || b.holdingNumber - a.holdingNumber)
          ?.slice(0, this.total) ?? []
      )
    },
    holdingsPageData() {
      return this.holdingsData.slice(0, (this.holdingsPageNum + 1) * this.holdingsPageSize)
    }
  },
  watch: {
    holdingsPageData(val) {
      if (val.length % this.holdingsPageSize) {
        this.holdingsFinished = true
      }
    }
  },
  created() {
    this.getManagers()
    this.getHoldings()
  },
  methods: {
    async getManagers() {
      this.loading = true
      const res = await this.$post(this.$api.f10[this.market] + '/summary/manager', {
        symbol: this.symbol
      })
      this.managers = res.data ?? []
      this.loading = false
      this.managersFinished = true
    },
    async getHoldings() {
      this.loading = true
      const search = this.getSearchInfo()
      if (!search) return

      const res = await this.$post(search.api, search.params)
      this.holdings = res.data ?? []
      this.loading = false
    },
    holdLoadMore() {
      if (this.holdingsFinished) return

      this.holdingsPageNum += 1
      if ((this.holdingsPageNum + 1) * this.holdingsPageSize >= this.holdingsData.length) {
        this.holdingsFinished = true
      }
    },
    getSearchInfo() {
      const searchInfo = {
        hk: {
          api: this.$api.f10.hk + '/summary/holders-equity-details',
          params: {
            symbol: this.symbol
          }
        },
        us: {
          api: this.$api.f10.us + '/summary/manager-hold-details',
          params: {
            symbol: this.symbol,
            startDate: '1990-01-01'
          }
        }
      }
      return searchInfo[this.market]
    }
  }
}
</script>

<style></style>
